import { Box, CircularProgress, Container, Fab, Link, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import { getSingleLoadingSelector } from '@ro-loading';
import { FC, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { feedCompilationAction } from './compilation.action';
import { CompilationList } from './components';

interface CompilationListPageProps {}

export const CompilationListPage: FC<CompilationListPageProps> = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => getSingleLoadingSelector(state, 'feedCompilation'));

  useEffect(() => {
    dispatch(feedCompilationAction.started());
  }, []);

  return (
    <Container sx={{ position: 'relative' }}>
      <Typography sx={{ marginBottom: '2rem' }} variant="h2">
        Подборки
      </Typography>
      {isLoading ? (
        <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <CircularProgress />
        </Box>
      ) : (
        <CompilationList />
      )}
      <Fab
        sx={{ position: 'fixed', bottom: '4rem', right: '4rem', zIndex: 2000 }}
        component={Link}
        href="/compilation/create"
        target="_blank"
        rel="noopener noreferrer"
        size="large"
        color="primary"
      >
        <Add />
      </Fab>
    </Container>
  );
};
